/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmUpdatePlan
 */
export interface ConfirmUpdatePlan {
    /**
     * プランID
     * @type {string}
     * @memberof ConfirmUpdatePlan
     */
    id: string;
    /**
     * プラン名
     * @type {string}
     * @memberof ConfirmUpdatePlan
     */
    name: string;
    /**
     * 料金ラベル
     * @type {string}
     * @memberof ConfirmUpdatePlan
     */
    priceLabel: string;
    /**
     * プランの開始日
     * @type {string}
     * @memberof ConfirmUpdatePlan
     */
    startDate: string;
    /**
     * プランの終了日
     * @type {string}
     * @memberof ConfirmUpdatePlan
     */
    endDate: string | null;
    /**
     * 自動更新
     * @type {boolean}
     * @memberof ConfirmUpdatePlan
     */
    isAutoRenewable: boolean;
    /**
     * 一括支払い
     * @type {boolean}
     * @memberof ConfirmUpdatePlan
     */
    isLumpSumPayment: boolean;
}

export function ConfirmUpdatePlanFromJSON(json: any): ConfirmUpdatePlan {
    return ConfirmUpdatePlanFromJSONTyped(json, false);
}

export function ConfirmUpdatePlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmUpdatePlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'priceLabel': json['price_label'],
        'startDate': json['start_date'],
        'endDate': json['end_date'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
    };
}

export function ConfirmUpdatePlanToJSON(value?: ConfirmUpdatePlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'price_label': value.priceLabel,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
    };
}

